import { render, staticRenderFns } from "./ComplaintLog.vue?vue&type=template&id=7e080796&scoped=true&"
import script from "./ComplaintLog.vue?vue&type=script&lang=js&"
export * from "./ComplaintLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e080796",
  null
  
)

export default component.exports